<div *ngIf="authService.isLoggedIn$ | async" class="app-dashboard-container">
  <div class="notifications-messages-area">
    <ng-container
      *ngIf="!alertsHidden && globalStateProviderService.alerts.length"
    >
      <ng-container
        *ngIf="
          globalStateProviderService.alerts.length <= 3;
          else moreAlertsContainer
        "
      >
        <div
          *ngFor="let alert of globalStateProviderService.alerts"
          class="alert alert-warning"
        >
          <div class="page-wrapper">
            <span
              class="alert-text"
              [innerHTML]="sanitizeHtml(alert.content)"
            ></span>
            <i class="fal fa-times close-alert" (click)="hideAlert(alert)"></i>
          </div>
        </div>
      </ng-container>
      <ng-template #moreAlertsContainer>
        <ng-container *ngIf="globalStateProviderService.alerts.length > 3">
          <div class="alert alert-info">
            <div class="page-wrapper">
              <span
                class="alert-text"
                [innerHtml]="moreThan3MessagesNotification"
                >You have notifications, check
                <strong>My messages</strong></span
              >
              <i class="fal fa-times close-alert" (click)="hideAlert()"></i>
            </div>
          </div>
        </ng-container>
      </ng-template>
    </ng-container>
  </div>
  <app-my-account-page
    *ngIf="showMyAccountPage"
    class="page-wrapper"
  ></app-my-account-page>
  <ng-container *ngIf="!hideMyApplications">
    <app-dashboard-tabs></app-dashboard-tabs>
  </ng-container>
</div>
<ng-container *ngIf="!hideListOfServices">
  <a *ifIframe="false" id="services-list-anchor"></a>
  <app-service-list *ifIframe="false"></app-service-list>
</ng-container>
